export const PLAYER_COLORS = [
    0xADDC7F, //green
    0xFFDC70, //yellow
    0xFFBF7F, //orange
    0xFF9F7F, //red-orange
    0xFF7F7F, //red
    0xFF7FBF, //pink
    0xBF7FFF, //purple-pink
    0x9F7FFF, //purple
    0x7F7FFF, //blue   
];
export const LIGHT_PLAYER_COLORS = [
    0xC7EFA0, //green
    0xFFE9A8, //yellow
    0xFFD2A6, //orange
    0xFFBCA6, //red-orange
    0xFFA6A6, //red
    0xFFA8D4, //pink
    0xD4A8FF, //purple-pink
    0xBEA8FF, //purple
    0xA8A8FF, //blue
];
export const WASHED_PLAYER_COLORS = [
    0xF9FFF2, //green
    0xFFFCF2, //yellow
    0xFFF9F2, //orange
    0xFFF5F2, //red-orange
    0xFFF2F2, //red
    0xFFF2F9, //pink
    0xF9F2FF, //purple-pink
    0xF5F2FF, //purple
    0xF2F2FF // blue
];
export const MISSING_PLAYER_COLOR = 0xBFBFBF;
export const LIGHT_MISSING_PLAYER_COLOR = 0xD4D4D4;
export const WASHED_MISSING_PLAYER_COLOR = 0xF7F7F7;
export function getPlayerColor(playerIndex) {
    return (playerIndex !== undefined) ? PLAYER_COLORS[playerIndex] : MISSING_PLAYER_COLOR;
}
export function getLightPlayerColor(playerIndex) {
    const result = (playerIndex !== undefined) ? LIGHT_PLAYER_COLORS[playerIndex] : LIGHT_MISSING_PLAYER_COLOR;
    return result;
}
export function getWashedPlayerColor(playerIndex) {
    const result = (playerIndex !== undefined) ? WASHED_PLAYER_COLORS[playerIndex] : WASHED_MISSING_PLAYER_COLOR;
    return result;
}
//# sourceMappingURL=PlayerColors.js.map